var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBank = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.834 7.518h21.082l.02-2.99L12.392 0 1.834 4.475v3.043ZM21.408 6H3.355v-.51l9.037-3.833 9.016 3.872V6ZM1.847 18.046v4.436H.378V24h24v-1.518h-1.475v-4.436H19.84V8.944h-1.514v9.102h-2.95V8.944H13.86v9.102h-2.957V8.944H9.388v9.102H6.365V8.944H4.85v9.102H1.847Zm19.541 1.519v2.917H3.362v-2.917h18.026Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Bank.a1dcddff9276f15d1a4b570b93c9235e.svg";